import { backgroundVariants } from '@rockalingua/ui';

export const BACKGROUND_VARIANTS = {
  DEFAULT: backgroundVariants.default,
  MAIN: backgroundVariants.main,
};
